import { createApi } from '@reduxjs/toolkit/query/react';

import { customBaseQuery } from '@/lib/baseQuery';
import { ApiResponse } from '@/shared/types';
import { mapObjectKeysToCamelCase } from '@/utils/object-mapper-utils';

export const leadApi = createApi({
  reducerPath: 'leadApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getLeadList: builder.query<
      ApiResponse<any>,
      {
        filter: string;
        page: number;
        email?: string;
        dateRange?: [string, string];
      }
    >({
      query: ({ filter, page, email, dateRange }) => {
        return {
          url: `v1/online-assessment/lead/list`,
          method: 'GET',
          params: {
            filter,
            page: page,
            ...(email && { email }),
            ...(dateRange && {
              start_date: dateRange[0],
              end_date: dateRange[1],
            }),
          },
        };
      },
    }),
    getLeadStepData: builder.query<any, { id: string }>({
        query: ({ id }) => {
          return {
            url: `v1/online-assessment/lead/${id}`,
            method: 'GET',
          };
        },
      }),
  }),

  
});

export const {
  useGetLeadListQuery,
  useGetLeadStepDataQuery,
} = leadApi;
